import client from '../request'

const getAll = '/stories'

const get = (id) => {
  return `/stories/${id}`
}

const create = (data) => {
  return client.post('/stories', data)
}

const update = (id, data) => {
  return client.put(`/stories/${id}`, data)
}

const toRow = (data) => {
  if (data?.data?.length > 0) {
    return data.data.map((element) => {
      return {
        ...element,
        key: element.id
      }
    })
  }

  return []
}

const toPaginate = (data) => {
  return {
    total: data?.meta?.total ?? 0
  }
}

const remove = (id) => {
  return client.delete(`/stories/${id}`)
}

const StoryService = {
  getAll,
  get,
  create,
  update,
  toPaginate,
  toRow,
  remove
}

export default StoryService
